import { getCrmOrigin } from "@/lib/urls";

export function resolveReadyWorkspaceURL(value: unknown): string {
  const crmOrigin = getCrmOrigin();
  const fallback = `${crmOrigin}/web`;
  if (typeof value !== "string") return fallback;

  const route = value.trim();
  const hasControlCharacter = Array.from(route).some((character) => {
    const code = character.charCodeAt(0);
    return code <= 0x1f || code === 0x7f;
  });
  if (!route.startsWith("/") || route.includes("\\") || hasControlCharacter) {
    return fallback;
  }

  try {
    const parsed = new URL(route, crmOrigin);
    if (parsed.origin !== crmOrigin) return fallback;
    return parsed.toString();
  } catch {
    return fallback;
  }
}
